export const SIGN_IN_PATH = '/sign-in';

type UrlParts = Pick<Location, 'pathname' | 'search' | 'hash'>;

// Only same-origin absolute paths; '//host' and '/\host' are protocol-relative and would leave the app.
export const getSafeRedirect = (search: string): string => {
  const redirect = new URLSearchParams(search).get('redirect');
  if (!redirect || !redirect.startsWith('/') || redirect.startsWith('//') || redirect.startsWith('/\\')) {
    return '/';
  }
  return redirect;
};

// Sign-in URL that returns to the full current location (path, query and hash) once signed in.
export const buildSignInPath = ({ pathname, search, hash }: UrlParts): string => {
  if (pathname === SIGN_IN_PATH) {
    const redirect = getSafeRedirect(search);
    return redirect === '/' ? SIGN_IN_PATH : `${SIGN_IN_PATH}?redirect=${encodeURIComponent(redirect)}`;
  }
  return `${SIGN_IN_PATH}?redirect=${encodeURIComponent(pathname + search + hash)}`;
};
